import * as React from "react";

export function IosTime(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" {...props}>
      <path
        data-name="Icon ionic-ios-time"
        d="M8 0a8 8 0 108 8 8 8 0 00-8-8zm.538 8.692A.54.54 0 018 9.23H4.308a.538.538 0 110-1.077h3.154V3.077a.538.538 0 011.077 0z"
        fill="#fff"
      />
    </svg>
  );
}

export const MemoIosTime = React.memo(IosTime);

function Setting(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20.637 20.637" {...props}>
      <defs>
        <style>
          {
            ".prefix__cls-1{fill:none;stroke:#33c2df;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"
          }
        </style>
      </defs>
      <g
        id="prefix__Icon_feather-settings"
        data-name="Icon feather-settings"
        transform="translate(-.5 -.5)"
      >
        <path
          id="prefix__Path_3503"
          data-name="Path 3503"
          className="prefix__cls-1"
          d="M18.583 16.041a2.541 2.541 0 11-2.542-2.541 2.541 2.541 0 012.542 2.541z"
          transform="translate(-5.223 -5.223)"
        />
        <path
          id="prefix__Path_3504"
          data-name="Path 3504"
          className="prefix__cls-1"
          d="M17.087 13.36a1.4 1.4 0 00.28 1.542l.051.051a1.7 1.7 0 11-2.4 2.4l-.051-.051a1.409 1.409 0 00-2.389 1v.144a1.694 1.694 0 11-3.388 0v-.076a1.4 1.4 0 00-.915-1.279 1.4 1.4 0 00-1.542.28l-.051.051a1.7 1.7 0 11-2.4-2.4l.051-.051a1.409 1.409 0 00-1-2.389h-.139a1.694 1.694 0 110-3.388h.076a1.4 1.4 0 001.28-.917 1.4 1.4 0 00-.28-1.542l-.051-.051a1.7 1.7 0 112.4-2.4l.051.051a1.4 1.4 0 001.542.28h.068a1.4 1.4 0 00.847-1.279v-.142a1.694 1.694 0 113.388 0v.076a1.409 1.409 0 002.389 1l.051-.051a1.7 1.7 0 112.4 2.4l-.051.051a1.4 1.4 0 00-.28 1.542v.068a1.4 1.4 0 001.279.847h.144a1.694 1.694 0 110 3.388h-.076a1.4 1.4 0 00-1.279.847z"
        />
      </g>
    </svg>
  );
}
export const SettingIconNew = React.memo(Setting);

function GreentickIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 13" {...props}>
      <g data-name="Group 3471">
        <g data-name="Rectangle 1195" fill="#00ff27" stroke="#707070">
          <rect width={16} height={13} rx={4} stroke="none" />
          <rect x={0.5} y={0.5} width={15} height={12} rx={3.5} fill="none" />
        </g>
        <path
          data-name="Icon awesome-check"
          d="M7.664 8.861L5.742 6.94a.3.3 0 010-.418l.413-.419a.3.3 0 01.418 0l1.3 1.295 2.773-2.773a.3.3 0 01.418 0l.418.418a.3.3 0 010 .418l-3.4 3.4a.3.3 0 01-.418 0z"
        />
      </g>
    </svg>
  );
}
export const Greentick = React.memo(GreentickIcon);

export function ClockIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 13" {...props}>
      <g data-name="Group 3472">
        <g data-name="Rectangle 1194" fill="#fff" stroke="#707070">
          <rect width={16} height={13} rx={4} stroke="none" />
          <rect x={0.5} y={0.5} width={15} height={12} rx={3.5} fill="none" />
        </g>
        <path
          data-name="Icon awesome-clock"
          d="M8.283 3.001a3.284 3.284 0 103.284 3.283 3.283 3.283 0 00-3.284-3.283zm.754 4.637l-1.165-.85a.16.16 0 01-.065-.128V4.431a.159.159 0 01.159-.159h.636a.159.159 0 01.159.159v1.823l.841.612a.159.159 0 01.035.222l-.373.514a.16.16 0 01-.227.036z"
        />
      </g>
    </svg>
  );
}
export const Clock = React.memo(ClockIcon);

function CalendarGraphIcon(props) {
  return (
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      style={{ transform: props.flip ? "rotate(3.142rad)" : "none" }}
      {...props}
    >
      <g data-name="Group 3462" transform="translate(-816 -1164)">
        <circle
          data-name="Ellipse 109"
          cx={8}
          cy={8}
          r={8}
          transform="translate(816 1164)"
          fill="#ad911b"
        />
        <path
          data-name="Icon awesome-calendar-check"
          d="M827.772 1169.983h-7.035a.2.2 0 01-.2-.2v-.6a.8.8 0 01.8-.8h.8v-.855a.2.2 0 01.2-.2h.664a.2.2 0 01.2.2v.863h2.115v-.863a.2.2 0 01.2-.2h.664a.2.2 0 01.2.2v.863h.8a.8.8 0 01.8.8v.6a.2.2 0 01-.208.192zm-7.035.531h7.035a.2.2 0 01.2.2v4.314a.8.8 0 01-.8.8h-5.835a.8.8 0 01-.8-.8v-4.315a.2.2 0 01.2-.199z"
          fill="#fff"
        />
      </g>
    </svg>
  );
}
export const Calendar = React.memo(CalendarGraphIcon);

function ArrowIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 60.37 16.745" {...props}>
      <g data-name="Group 3463">
        <path
          data-name="Line 243"
          fill="none"
          stroke="#c3c3c3"
          strokeWidth={5}
          d="M.023 7.873l54 .5"
        />
        <path
          data-name="Icon ionic-md-arrow-dropleft"
          d="M47.676 0L60.37 8.372l-12.694 8.373z"
          fill="#c3c3c3"
        />
      </g>
    </svg>
  );
}
export const Arrow = React.memo(ArrowIcon);

function CheckIcon(props) {
  return (
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      {...props}
      style={{ transform: props.flip ? "rotate(3.142rad)" : "none" }}
    >
      <g data-name="Group 3461" transform="translate(-893 -1164)">
        <circle
          data-name="Ellipse 108"
          cx={8}
          cy={8}
          r={8}
          transform="translate(893 1164)"
          fill="#1bad1b"
        />
        <path
          data-name="Icon awesome-check"
          d="M899.842 1174.585l-2.345-2.345a.361.361 0 010-.51l.51-.51a.361.361 0 01.51 0l1.58 1.58 3.385-3.385a.361.361 0 01.51 0l.51.51a.361.361 0 010 .51l-4.15 4.15a.361.361 0 01-.51 0z"
          fill="#fff"
        />
      </g>
    </svg>
  );
}
export const Check = React.memo(CheckIcon);

function CrosIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 15 15" {...props}>
      <g data-name="Group 3355">
        <g data-name="Ellipse 397" fill="#fff" stroke="#d3d3d3">
          <circle cx={7.5} cy={7.5} r={7.5} stroke="none" />
          <circle cx={7.5} cy={7.5} r={7} fill="none" />
        </g>
        <path
          data-name="Icon metro-cross"
          d="M11.439 9.905h0l-2.4-2.4 2.4-2.4h0a.248.248 0 000-.35L10.303 3.61a.248.248 0 00-.35 0h0l-2.4 2.4-2.409-2.4h0a.248.248 0 00-.35 0L3.658 4.746a.248.248 0 000 .35h0l2.4 2.4-2.4 2.4h0a.248.248 0 000 .35l1.136 1.145a.248.248 0 00.35 0h0l2.4-2.4 2.4 2.4h0a.248.248 0 00.35 0l1.136-1.136a.248.248 0 000-.35z"
          stroke="#fff"
        />
      </g>
    </svg>
  );
}
export const Cros = React.memo(CrosIcon);

function Add(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 21.118 21.118" {...props}>
      <path
        data-name="Icon material-add-to-photos"
        d="M2.112 4.224H0v14.782a2.118 2.118 0 002.112 2.112h14.783v-2.112H2.112zM19.006 0H6.335a2.118 2.118 0 00-2.111 2.112v12.671a2.118 2.118 0 002.112 2.112h12.67a2.118 2.118 0 002.112-2.112V2.112A2.118 2.118 0 0019.006 0zM17.95 9.5h-4.223v4.224h-2.112V9.5H7.391V7.391h4.224V3.168h2.112v4.224h4.223z"
        fill="#fff"
        opacity={0.272}
      />
    </svg>
  );
}
export const AddIcon = React.memo(Add);

function UploadIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 29.358 20.551" {...props}>
      <path
        data-name="Icon awesome-cloud-upload-alt"
        d="M24.661 8.927a4.409 4.409 0 00-4.11-5.991 4.381 4.381 0 00-2.445.743A7.34 7.34 0 004.4 7.339c0 .124 0 .248.009.372A6.607 6.607 0 006.606 20.55h16.88A5.871 5.871 0 0024.66 8.926zm-6.615 2.817h-3v5.138a.736.736 0 01-.734.734h-2.2a.736.736 0 01-.734-.734v-5.139h-3a.733.733 0 01-.518-1.252l4.835-4.835a.736.736 0 011.037 0l4.835 4.835a.734.734 0 01-.518 1.252z"
        fill="#fff"
      />
    </svg>
  );
}
export const Upload = React.memo(UploadIcon);

export function ArrowDownIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 10.943 5.471" {...props}>
      <path
        data-name="Icon ionic-md-arrow-dropdown"
        d="M0 0l5.471 5.471L10.943 0z"
        fill="#707070"
      />
    </svg>
  );
}
export function ArrowDownWhiteIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 10.943 5.471" {...props}>
      <path
        data-name="Icon ionic-md-arrow-dropdown"
        d="M0 0l5.471 5.471L10.943 0z"
        fill="#FFFFFF"
      />
    </svg>
  );
}
export function ArrowExpandIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 41 41" {...props}>
      <defs>
        <style>
          {
            ".prefix__cls-2{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"
          }
        </style>
      </defs>
      <g
        id="prefix__Group_3226"
        data-name="Group 3226"
        transform="translate(-24 -910)"
      >
        <g
          id="prefix__Ellipse_23"
          data-name="Ellipse 23"
          transform="translate(24 910)"
          fill="#6d6e7e"
          stroke="#232631"
          strokeWidth={4}
        >
          <circle cx={20.5} cy={20.5} r={20.5} stroke="none" />
          <circle cx={20.5} cy={20.5} r={18.5} fill="none" />
        </g>
        <g
          id="prefix__Icon_feather-arrow-right"
          data-name="Icon feather-arrow-right"
          transform="translate(31.287 917.287)"
        >
          <path
            id="prefix__Path_436"
            data-name="Path 436"
            className="prefix__cls-2"
            d="M7.5 18h11.426"
            transform="translate(0 -4.787)"
          />
          <path
            id="prefix__Path_437"
            data-name="Path 437"
            className="prefix__cls-2"
            d="M18 7.5l5.713 5.713L18 18.926"
            transform="translate(-4.787)"
          />
        </g>
      </g>
    </svg>
  );
}

export function ArrowLeftIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 4.503 7.876" {...props}>
      <path
        data-name="Icon ionic-ios-arrow-back"
        d="M1.357 3.937L4.337.959a.564.564 0 10-.8-.795L.164 3.538a.562.562 0 00-.016.776l3.391 3.4a.564.564 0 00.8-.795z"
        fill="#fff"
      />
    </svg>
  );
}
export function ArrowRightIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 4.503 7.876" {...props}>
      <path
        data-name="Icon ionic-ios-arrow-back"
        d="M3.149 3.937L.169.959a.564.564 0 11.8-.795l3.37 3.374a.562.562 0 01.016.776l-3.391 3.4a.564.564 0 01-.8-.795z"
        fill="#fff"
      />
    </svg>
  );
}
export function BellIcon(props) {
  let fillColor = "#343540";
  if (props.color === "red") {
    fillColor = "#F13F3F";
  } else {
    fillColor = "#07ba00";
  }
  return (
    <svg width="1em" height="1em" viewBox="0 0 17.272 20.413" {...props}>
      <path
        data-name="Icon ionic-md-notifications-outline"
        d="M8.685 3.556a7.094 7.094 0 011.173.22 5 5 0 013.812 4.9v6.262l.457.459.382.384H2.763l.382-.384.457-.459V8.675a5 5 0 013.812-4.9 8.687 8.687 0 011.173-.22m.049-3.556A1.5 1.5 0 007.112 1.53v.715a6.615 6.615 0 00-5.08 6.43v5.613L0 16.33v1.021h17.275V16.33l-2.032-2.041V8.675a6.615 6.615 0 00-5.08-6.43v-.714A1.5 1.5 0 008.639 0zm2.032 18.371H6.604a2.032 2.032 0 104.064 0z"
        fill={fillColor}
      />
    </svg>
  );
}
export function IconBellDashboard(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 12.004 13.719" {...props}>
      <path
        data-name="Icon awesome-bell"
        d="M6 13.719A1.715 1.715 0 007.716 12H4.288A1.715 1.715 0 006 13.719zm5.771-4.011c-.518-.556-1.486-1.393-1.486-4.134a4.231 4.231 0 00-3.426-4.158V.857a.857.857 0 10-1.714 0v.558a4.231 4.231 0 00-3.428 4.158c0 2.741-.969 3.578-1.486 4.134a.837.837 0 00-.231.582.858.858 0 00.86.857h10.284a.858.858 0 00.86-.857.837.837 0 00-.231-.582z"
        fill="#ff7474"
      />
    </svg>
  );
}
export function IconFileDownload(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 15.457 20.609" {...props}>
      <path
        data-name="Icon awesome-file-download"
        d="M9.017 5.474V0H.966A.964.964 0 000 .966v18.677a.964.964 0 00.966.966h13.525a.964.964 0 00.966-.966V6.44H9.983a.969.969 0 01-.966-.966zm3.077 8.508l-3.881 3.852a.686.686 0 01-.968 0l-3.881-3.852a.644.644 0 01.453-1.1H6.44V9.661a.644.644 0 01.644-.644h1.289a.644.644 0 01.644.644v3.22h2.623a.644.644 0 01.454 1.101zm3.081-9.756L11.235.282A.965.965 0 0010.55 0h-.25v5.152h5.152v-.245a.963.963 0 00-.277-.68z"
        fill="#33c2df"
      />
    </svg>
  );
}
export function CalendarIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 10.429 11.919" {...props}>
      <path
        data-name="Icon awesome-calendar-alt"
        d="M0 10.8a1.118 1.118 0 001.117 1.117h8.194a1.118 1.118 0 001.118-1.117V4.47H0zm7.449-4.561a.28.28 0 01.279-.279h.932a.28.28 0 01.279.279v.931a.28.28 0 01-.279.279h-.931a.28.28 0 01-.279-.279zm0 2.98a.28.28 0 01.279-.279h.932a.28.28 0 01.279.279v.931a.28.28 0 01-.279.279h-.931a.28.28 0 01-.279-.279zM4.47 6.239a.28.28 0 01.279-.279h.931a.28.28 0 01.279.279v.931a.28.28 0 01-.279.279h-.931a.28.28 0 01-.279-.279zm0 2.98a.28.28 0 01.279-.279h.931a.28.28 0 01.279.279v.931a.28.28 0 01-.279.279h-.931a.28.28 0 01-.279-.279zm-2.98-2.98a.28.28 0 01.279-.279H2.7a.28.28 0 01.279.279v.931a.28.28 0 01-.279.279h-.931a.28.28 0 01-.279-.279zm0 2.98a.28.28 0 01.279-.279H2.7a.28.28 0 01.279.279v.931a.28.28 0 01-.279.279h-.931a.28.28 0 01-.279-.279zM9.311 1.49H8.194V.372A.374.374 0 007.822 0h-.745A.374.374 0 006.7.372V1.49H3.725V.372A.374.374 0 003.352 0h-.745a.374.374 0 00-.372.372V1.49H1.117A1.118 1.118 0 000 2.607v1.118h10.429V2.607A1.118 1.118 0 009.311 1.49z"
        fill="#fff"
      />
    </svg>
  );
}
export function DashboardIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 13.5 13.5" {...props}>
      <path
        data-name="Icon material-dashboard"
        d="M0 7.5h6V0H0zm0 6h6V9H0zm7.5 0h6V6h-6zM7.5 0v4.5h6V0z"
        fill="#a5a4bf"
      />
    </svg>
  );
}
export function DownIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 8 7" {...props}>
      <path
        data-name="Polygon 21"
        d="M4 7L0 0h8z"
        fill={props.type === "reverse" ? "#07ba00" : "#ff0505"}
      />
    </svg>
  );
}
export function DragIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 9.649 15.649" {...props}>
      <defs>
        <linearGradient
          id="prefix__linear-gradient"
          x1={1.051}
          y1={1.235}
          x2={-0.08}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#232631" />
          <stop offset={1} stopColor="#232631" />
        </linearGradient>
        <style>
          {".prefix__cls-1{stroke:#f8f8f8;fill:url(#prefix__linear-gradient)}"}
        </style>
      </defs>
      <g
        id="prefix__Group_3227"
        data-name="Group 3227"
        transform="translate(-6.5 -14.416)"
      >
        <path
          id="prefix__Icon_metro-more-vert"
          data-name="Icon metro-more-vert"
          className="prefix__cls-1"
          d="M17.255 11.374a1.831 1.831 0 10-1.831-1.831 1.831 1.831 0 001.831 1.831zm0 1.831a1.831 1.831 0 101.831 1.831 1.831 1.831 0 00-1.831-1.83zm0 5.494a1.831 1.831 0 101.831 1.831 1.831 1.831 0 00-1.831-1.83z"
          transform="translate(-8.424 7.204)"
        />
        <path
          id="prefix__Icon_metro-more-vert-2"
          data-name="Icon metro-more-vert"
          className="prefix__cls-1"
          d="M17.255 11.374a1.831 1.831 0 10-1.831-1.831 1.831 1.831 0 001.831 1.831zm0 1.831a1.831 1.831 0 101.831 1.831 1.831 1.831 0 00-1.831-1.83zm0 5.494a1.831 1.831 0 101.831 1.831 1.831 1.831 0 00-1.831-1.83z"
          transform="translate(-3.438 7.204)"
        />
      </g>
    </svg>
  );
}
export function EditIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 18.896 16.793" {...props}>
      <path
      className="noBarClick"
        data-name="Icon awesome-edit"
        d="M13.207 2.726l2.959 2.959a.321.321 0 010 .453L9 13.302l-3.044.338a.638.638 0 01-.705-.705l.339-3.042 7.165-7.165a.321.321 0 01.452-.002zm5.314-.751l-1.6-1.6a1.283 1.283 0 00-1.811 0l-1.161 1.16a.321.321 0 000 .453l2.959 2.959a.321.321 0 00.453 0l1.161-1.161a1.283 1.283 0 000-1.811zM12.6 11.354v3.339H2.1v-10.5h7.538a.4.4 0 00.279-.115l1.312-1.312a.394.394 0 00-.279-.673H1.575A1.575 1.575 0 000 3.671v11.547a1.575 1.575 0 001.575 1.575h11.547a1.575 1.575 0 001.578-1.575v-5.176a.394.394 0 00-.672-.279l-1.312 1.312a.4.4 0 00-.116.279z"
        fill="#fff"
      />
    </svg>
  );
}

export function IconAddressCard(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 19.839 15.43" {...props}>
      <path
        data-name="Icon awesome-address-card"
        d="M18.186 0H1.653A1.654 1.654 0 000 1.65v12.127a1.654 1.654 0 001.653 1.653h16.533a1.654 1.654 0 001.653-1.653V1.65A1.654 1.654 0 0018.186 0zM6.062 3.307a2.2 2.2 0 11-2.2 2.2 2.206 2.206 0 012.2-2.2zm3.858 8.156a.722.722 0 01-.772.661H2.976a.722.722 0 01-.772-.661v-.661a2.169 2.169 0 012.315-1.984h.172a3.548 3.548 0 002.742 0H7.6a2.169 2.169 0 012.32 1.983zm7.715-1.819a.276.276 0 01-.276.276H12.4a.276.276 0 01-.276-.276v-.551a.276.276 0 01.276-.276h4.96a.276.276 0 01.276.276zm0-2.2a.276.276 0 01-.276.276H12.4a.276.276 0 01-.276-.276v-.555a.276.276 0 01.276-.276h4.96a.276.276 0 01.276.276zm0-2.2a.276.276 0 01-.276.276H12.4a.276.276 0 01-.276-.276v-.56a.276.276 0 01.276-.276h4.96a.276.276 0 01.276.276z"
        fill="#fff"
      />
    </svg>
  );
}

export function IconStripe(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 19.966 15.529" {...props}>
      <path
        data-name="Icon awesome-cc-stripe"
        d="M17.068 6.544c-.309 0-.648.232-.648.787h1.272c0-.554-.322-.787-.624-.787zM13 6.635a.738.738 0 00-.589.243l.007 1.83A.748.748 0 0013 8.94c.454 0 .759-.5.759-1.158-.001-.645-.313-1.151-.759-1.147zM18.3 0H1.664A1.664 1.664 0 000 1.664v12.2a1.664 1.664 0 001.664 1.664H18.3a1.664 1.664 0 001.664-1.664v-12.2A1.664 1.664 0 0018.3 0zM4.236 8.635c0 .887-.7 1.39-1.73 1.4a3.407 3.407 0 01-1.345-.285V8.576a3.149 3.149 0 001.348.392c.274 0 .471-.073.471-.3 0-.589-1.872-.367-1.872-1.73 0-.874.666-1.393 1.664-1.393A3.25 3.25 0 014 5.768v1.158a2.768 2.768 0 00-1.227-.316c-.26 0-.419.076-.419.267 0 .555 1.882.291 1.882 1.757zm2.385-1.962h-.936v1.751c0 .724.78.5.936.437v1a1.894 1.894 0 01-.863.163 1.239 1.239 0 01-1.279-1.265l.007-3.948 1.2-.257v1.068h.932zm2.565.083a.874.874 0 00-.939.257v2.926H7.016V5.622H8.08l.076.364a.838.838 0 011.026-.364zm1.529 3.182H9.477V5.622h1.237zm0-4.953l-1.238.265v-1l1.237-.263zm2.569 5.044a1.388 1.388 0 01-.87-.312v1.393l-1.231.26V5.622h1.085l.062.305a1.39 1.39 0 01.964-.385c.863 0 1.678.78 1.678 2.212 0 1.563-.8 2.27-1.685 2.274zm5.56-1.785h-2.41c.055.575.478.745.957.745a2.6 2.6 0 001.21-.274v.991a2.785 2.785 0 01-1.366.319A1.966 1.966 0 0115.2 7.789a2 2 0 011.882-2.25c1.168 0 1.778.995 1.778 2.257 0 .121-.01.378-.014.447z"
        fill="#909090"
      />
    </svg>
  );
}

export function IconPencilEdit(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 6.995 6.994" {...props}>
      <path
        data-name="Icon material-edit"
        d="M0 5.538v1.457h1.457l4.3-4.3L4.3 1.241zm6.881-3.967a.387.387 0 000-.548L5.972.114a.387.387 0 00-.548 0l-.711.711L6.17 2.282l.711-.711z"
        fill="#fff"
      />
    </svg>
  );
}
export function IconFlag(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 17.721 21.259" {...props}>
      <path
        data-name="Icon ionic-ios-flag"
        d="M17.201.93c-.172.028-.354.055-.548.078a32.634 32.634 0 01-3.355.288A20.371 20.371 0 018.969.621a21.2 21.2 0 00-4.462-.62C1.396.001.338.671.228.743L0 .9v19.562a.79.79 0 00.681.792.775.775 0 00.869-.77v-8.548a.45.45 0 01.354-.436 13.434 13.434 0 012.6-.216 20.736 20.736 0 014.241.858 19.518 19.518 0 004.617.637 26.247 26.247 0 003.975-.365.446.446 0 00.382-.437V1.367a.451.451 0 00-.518-.437z"
        fill="#33c2df"
      />
    </svg>
  );
}
export function ExportIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 31 21.7" {...props}>
      <path
        data-name="Icon awesome-cloud-download-alt"
        d="M26.04 9.426A4.656 4.656 0 0021.7 3.1a4.626 4.626 0 00-2.582.785A7.751 7.751 0 004.65 7.75c0 .131 0 .262.01.392A6.977 6.977 0 006.975 21.7H24.8a6.2 6.2 0 001.24-12.274zm-6.437 4.3L14.5 18.828a.778.778 0 01-1.095 0L8.3 13.722a.775.775 0 01.547-1.322h3.168V6.975a.777.777 0 01.775-.775h2.325a.777.777 0 01.775.775V12.4h3.168a.775.775 0 01.547 1.322z"
        fill="#33c2df"
      />
    </svg>
  );
}
export function Forecast(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 14.273 14.273" {...props}>
      <path
        data-name="Icon material-collections-bookmark"
        d="M1.427 2.855H0v9.991a1.432 1.432 0 001.427 1.427h9.991v-1.427H1.427zM12.846 0H4.282a1.432 1.432 0 00-1.427 1.427v8.564a1.432 1.432 0 001.427 1.427h8.564a1.432 1.432 0 001.427-1.427V1.427A1.432 1.432 0 0012.846 0zm0 7.137l-1.784-1.07-1.784 1.07v-5.71h3.568z"
        fill="#a5a4bf"
      />
    </svg>
  );
}
export function ForecastIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 10.101 10.101" {...props}>
      <path
        data-name="Icon open-graph"
        d="M8.876 0L5.05 3.788 3.788 2.525 0 6.351l1.263 1.262L3.788 5.05 5.05 6.313l5.05-5.05zM0 8.838V10.1h10.1V8.838z"
        fill="#33c2df"
      />
    </svg>
  );
}
export function IconCross(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 13.944 13.944" {...props}>
      <path
        data-name="Icon metro-cross"
        d="M12.82 10.588h0L9.206 6.972l3.613-3.614h0a.373.373 0 000-.526l-1.707-1.707a.373.373 0 00-.526 0h0L6.972 4.739 3.358 1.125h0a.373.373 0 00-.526 0L1.125 2.832a.373.373 0 000 .526h0l3.613 3.614-3.613 3.616h0a.373.373 0 000 .526l1.707 1.707a.373.373 0 00.526 0h0l3.614-3.614 3.614 3.614h0a.373.373 0 00.526 0l1.707-1.707a.373.373 0 000-.526z"
        fill="#fff"
        stroke="#3a3b48"
        strokeWidth={2}
      />
    </svg>
  );
}
export function IconLeft(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 9.692 16.953" {...props}>
      <path
        data-name="Icon ionic-ios-arrow-back"
        d="M2.921 8.474l6.415-6.41A1.212 1.212 0 007.62.353L.349 7.616a1.209 1.209 0 00-.035 1.671l7.3 7.313a1.212 1.212 0 101.716-1.711z"
        fill="#fff"
      />
    </svg>
  );
}
export function ImportIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 17.234 15.32" {...props}>
      <path
        data-name="Icon awesome-file-export"
        d="M11.49 3.648a.716.716 0 00-.209-.506L8.351.209A.718.718 0 007.843 0H7.66v3.83h3.83zm5.6 5.569l-2.868-2.885a.48.48 0 00-.82.338v1.948h-1.915v1.915H13.4v1.951a.48.48 0 00.82.338l2.864-2.888a.509.509 0 00.002-.718zm-11.341.838V9.1a.48.48 0 01.479-.479h5.262V4.788H7.421a.72.72 0 01-.721-.719V0H.718A.716.716 0 000 .718V14.6a.716.716 0 00.718.718h10.054a.716.716 0 00.718-.718v-4.067H6.224a.48.48 0 01-.479-.479z"
        fill="#33c2df"
      />
    </svg>
  );
}
export function InfoIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 10.228 10.228" {...props}>
      <path
        data-name="Icon ionic-ios-information-circle"
        d="M5.114 0a5.114 5.114 0 105.111 5.114A5.113 5.113 0 005.114 0zm.467 7.474h-.939V3.931h.939zm-.469-3.929a.491.491 0 11.513-.491.493.493 0 01-.513.491z"
        fill="#33c2df"
      />
    </svg>
  );
}
export function IconEnlargeArrow(props) {
  return (
    <svg
      fill="#0081c5"
      viewBox="0 0 512 512.04"
      xmlns="http://www.w3.org/2000/svg"
      width="17"
    >
      <path
        fill-rule="nonzero"
        fill="#0081c5"
        stroke="#fff"
        d="M99.15 310.32 70 281.18c-18.29-19.58-55.77-13.06-57.74 15.71L.04 473.59c-.92 22.88 15.22 39.81 37.8 38.36l174.9-11.42c27.01-3.28 38.55-38.1 18.87-57.79l-29.89-29.81 211.16-211.16 29.04 29.04c19.21 20.47 56.6 10.27 58.48-18.58l11.48-173.88c1.7-22.05-15.7-39.19-37.8-38.32L299.22 11.45c-28.2 3.43-38.03 38.92-18.23 58.73l29.16 29.15-211 210.99zm0 33.79L343.94 99.33l-46.05-46.05c-5.73-5.73-4.14-16.99 4.02-18.11l173.76-11.33c6.79-.44 13.34 4.64 12.49 11.83l-11.57 175.07c-.5 7.7-12.49 9.13-17.35 3.69l-.42-.52-45.94-45.93-244.92 244.91 46.77 46.73c5.48 5.62 2.62 16.22-4.81 17.2-57.06 3.72-118.94 10.13-175.53 11.36-8.09-.34-10.39-6.32-10.56-13.33l12.24-176.37c.45-6.77 12.54-5.48 16.61-.92l46.47 46.55z"
      />
    </svg>
  );
}
export function IconShrinkArrow(props) {
  return (
    <svg
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
    >
      <path
        fill="none"
        stroke="#0081c5"
        strokeWidth="40"
        d="m881.7 187.4-45.1-45.1a8.03 8.03 0 0 0 -11.3 0l-157.5 157.6-54.7-54.7a7.94 7.94 0 0 0 -13.5 4.7l-23.5 189.1c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 157.6-157.6c3-3 3-8.1-.1-11.2zm-442.7 388.7-189.2 23.5c-6.6.8-9.3 8.9-4.7 13.5l54.7 54.7-157.5 157.5a8.03 8.03 0 0 0 0 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l157.6-157.6 54.7 54.7a7.94 7.94 0 0 0 13.5-4.7l23.4-189.1a7.9 7.9 0 0 0 -8.9-8.9z"
      />
    </svg>
  );
}
export function LockIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="16px"
      height="16px"
    >
      <path
        d="M 12 1 C 8.6761905 1 6 3.6761905 6 7 L 6 8 C 4.9069372 8 4 8.9069372 4 10 L 4 20 C 4 21.093063 4.9069372 22 6 22 L 18 22 C 19.093063 22 20 21.093063 20 20 L 20 10 C 20 8.9069372 19.093063 8 18 8 L 18 7 C 18 3.6761905 15.32381 1 12 1 z M 12 3 C 14.27619 3 16 4.7238095 16 7 L 16 8 L 8 8 L 8 7 C 8 4.7238095 9.7238095 3 12 3 z M 6 10 L 18 10 L 18 20 L 6 20 L 6 10 z M 12 13 C 10.9 13 10 13.9 10 15 C 10 16.1 10.9 17 12 17 C 13.1 17 14 16.1 14 15 C 14 13.9 13.1 13 12 13 z"
        fill="#ffffff69"
      />
    </svg>
  );
}
export function WhiteInfoIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 10.228 10.228" {...props}>
      <path
        data-name="Icon ionic-ios-information-circle"
        d="M5.114 0a5.114 5.114 0 105.111 5.114A5.113 5.113 0 005.114 0zm.467 7.474h-.939V3.931h.939zm-.469-3.929a.491.491 0 11.513-.491.493.493 0 01-.513.491z"
        fill={props?.color}
      />
    </svg>
  );
}

export function InsightsIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 6.662 9.517" {...props}>
      <path
        data-name="Icon material-lightbulb-outline"
        d="M1.9 9.041a.477.477 0 00.476.476h1.9a.477.477 0 00.476-.476v-.476H1.9zM3.331 0a3.33 3.33 0 00-1.9 6.062v1.075a.477.477 0 00.476.476h2.855a.477.477 0 00.476-.476V6.062A3.33 3.33 0 003.331 0zm1.356 5.282l-.4.286v1.094h-1.9V5.567l-.4-.286a2.379 2.379 0 112.712 0z"
        fill="#33c2df"
      />
    </svg>
  );
}

export function ReportIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 36 36" {...props}>
      <rect x="6.48" y="18" width="5.76" height="11.52" rx="1" ry="1" />
      <rect x="15.12" y="6.48" width="5.76" height="23.04" rx="1" ry="1" />
      <rect x="23.76" y="14.16" width="5.76" height="15.36" rx="1" ry="1" />
    </svg>
  );
}

export function ManualOverideIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 10.642 14.985" {...props}>
      <path
        data-name="Icon ionic-ios-bookmark"
        d="M0 1.153V14.84a.169.169 0 00.266.115l4.855-3.314a.379.379 0 01.4 0l4.855 3.314a.169.169 0 00.266-.115V1.153A1.25 1.25 0 009.312 0H1.33A1.25 1.25 0 000 1.153z"
        fill="#33c2df"
      />
    </svg>
  );
}
export function NetCashIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 15.206 11.941" {...props}>
      <defs>
        <style>{".prefix__cls-3{fill:#a5a4bf}"}</style>
      </defs>
      <g
        id="prefix__Icon_ionic-ios-cash"
        data-name="Icon ionic-ios-cash"
        transform="translate(-2.25 -5.632)"
      >
        <path
          id="prefix__Path_150"
          data-name="Path 150"
          className="prefix__cls-3"
          d="M16.981 25.024H2.725a.475.475 0 100 .95h14.256a.475.475 0 000-.95z"
          transform="translate(0 -10.031)"
        />
        <path
          id="prefix__Path_151"
          data-name="Path 151"
          className="prefix__cls-3"
          d="M16.981 28.4H2.725a.475.475 0 100 .95h14.256a.475.475 0 000-.95z"
          transform="translate(0 -11.777)"
        />
        <path
          id="prefix__Path_152"
          data-name="Path 152"
          className="prefix__cls-3"
          d="M16.265 5.632H3.441A1.2 1.2 0 002.25 6.823v6.035a1.2 1.2 0 001.191 1.192h12.824a1.2 1.2 0 001.191-1.191V6.823a1.2 1.2 0 00-1.191-1.191zM5.033 12.964H3.811a.475.475 0 010-.95h1.222a.475.475 0 110 .95zm0-5.3H3.811a.475.475 0 010-.95h1.222a.475.475 0 010 .95zm4.82 4.888a2.715 2.715 0 112.715-2.715 2.719 2.719 0 01-2.715 2.719zm6.042.407h-1.222a.475.475 0 010-.95h1.222a.475.475 0 110 .95zm0-5.3h-1.222a.475.475 0 010-.95h1.222a.475.475 0 110 .95z"
        />
        <path
          id="prefix__Path_153"
          data-name="Path 153"
          className="prefix__cls-3"
          d="M17.871 12.557a1.8 1.8 0 11-1.8-1.8 1.8 1.8 0 011.8 1.8z"
          transform="translate(-6.219 -2.651)"
        />
      </g>
    </svg>
  );
}
export function OrdersIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 14.092 14.092" {...props}>
      <path
        data-name="Icon ionic-ios-list-box"
        d="M0 1.175v11.742a1.176 1.176 0 001.175 1.175h11.742a1.176 1.176 0 001.175-1.175V1.175A1.176 1.176 0 0012.917 0H1.175A1.174 1.174 0 000 1.175zm3.025 10.062a.676.676 0 11.583-.583.674.674 0 01-.583.583zm0-3.522a.676.676 0 11.583-.583.674.674 0 01-.583.583zm0-3.522a.676.676 0 11.583-.583.674.674 0 01-.583.583zm8.379 6.848h-6.1a.476.476 0 01-.474-.474.476.476 0 01.474-.474h6.1a.476.476 0 01.474.474.476.476 0 01-.475.474zm0-3.522h-6.1a.476.476 0 01-.474-.474.476.476 0 01.474-.474h6.1a.476.476 0 01.474.474.476.476 0 01-.475.473zm0-3.522h-6.1a.476.476 0 01-.471-.472.476.476 0 01.474-.474h6.1a.476.476 0 01.474.474.476.476 0 01-.478.471z"
        fill="#a5a4bf"
      />
    </svg>
  );
}
export function ProfileIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 17.928 19.919" {...props}>
      <defs>
        <style>
          {
            ".prefix__cls-4{fill:none;stroke:#343540;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"
          }
        </style>
      </defs>
      <g
        id="prefix__Icon_feather-user"
        data-name="Icon feather-user"
        transform="translate(-5 -3.5)"
      >
        <path
          id="prefix__Path_409"
          data-name="Path 409"
          className="prefix__cls-4"
          d="M21.928 28.473v-1.991a3.982 3.982 0 00-3.982-3.982H9.982A3.982 3.982 0 006 26.482v1.991"
          transform="translate(0 -6.054)"
        />
        <path
          id="prefix__Path_410"
          data-name="Path 410"
          className="prefix__cls-4"
          d="M19.964 8.482A3.982 3.982 0 1115.982 4.5a3.982 3.982 0 013.982 3.982z"
          transform="translate(-2.018)"
        />
      </g>
    </svg>
  );
}
export function ReceivablesIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 13.347 13.347" {...props}>
      <path
        data-name="Icon awesome-file-import"
        d="M.417 7.508A.418.418 0 000 7.925v.834a.418.418 0 00.417.417h2.92V7.508zm12.748-4.771L10.613.182A.625.625 0 0010.169 0h-.159v3.337h3.337v-.159a.624.624 0 00-.182-.441zm-3.989.808V0H3.962a.624.624 0 00-.626.626v6.882h3.338v-1.7a.418.418 0 01.714-.295L9.88 8.029a.444.444 0 010 .626l-2.495 2.513a.418.418 0 01-.714-.295v-1.7H3.337v3.545a.624.624 0 00.626.626h8.759a.624.624 0 00.626-.626V4.171H9.8a.627.627 0 01-.624-.626z"
        fill="#a5a4bf"
      />
    </svg>
  );
}
export function RedIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 10.125 9" {...props}>
      <defs>
        <clipPath id="prefix__a">
          <path fill="none" d="M0 0h10.125v9H0z" />
        </clipPath>
      </defs>
      <g clipPath="url(#prefix__a)">
        <path
          data-name="close"
          d="M6.814 4.5l2.9-2.587a1.008 1.008 0 000-1.575 1.324 1.324 0 00-1.766 0l-2.9 2.588L2.145.337a1.324 1.324 0 00-1.766 0 1.008 1.008 0 000 1.575L3.281 4.5.379 7.088a1.008 1.008 0 000 1.575A1.215 1.215 0 001.262 9a1.215 1.215 0 00.883-.337l2.9-2.588 2.9 2.588a1.324 1.324 0 001.766 0 1.008 1.008 0 000-1.575z"
          fill="red"
        />
      </g>
    </svg>
  );
}
export function RefreshIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" {...props}>
      <path
        data-name="Icon ionic-md-refresh"
        d="M8 14A6 6 0 018 2a5.813 5.813 0 014.2 1.8L9 7h7V0l-2.35 2.35a7.99 7.99 0 102.05 7.832h-2.116A5.958 5.958 0 018 14z"
        fill="#fff"
      />
    </svg>
  );
}
export function IconGraph(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 12.635 12.635" {...props}>
      <path
        data-name="Icon open-graph"
        d="M11.1 0L6.317 4.738 4.738 3.159 0 7.944l1.579 1.579 3.159-3.206L6.317 7.9l6.317-6.317zM0 11.055v1.579h12.635v-1.579z"
        fill="#33c2df"
      />
    </svg>
  );
}
export function IconExpandArrow(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 3.355 5.747" {...props}>
      <path
        data-name="Icon awesome-sort"
        d="M.823 5.609l2.39-2.39a.48.48 0 000-.681L.823.142A.483.483 0 000 .483v4.78a.483.483 0 00.823.346z"
        fill="#fff"
      />
    </svg>
  );
}
export function ScenarioIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 15.424 12.532" {...props}>
      <path
        data-name="Icon awesome-list-ul"
        d="M1.446 0a1.446 1.446 0 101.446 1.446A1.446 1.446 0 001.446 0zm0 4.82a1.446 1.446 0 101.446 1.446 1.446 1.446 0 00-1.446-1.441zm0 4.82a1.446 1.446 0 101.446 1.446A1.446 1.446 0 001.446 9.64zm13.5.482H5.3a.482.482 0 00-.482.482v.964a.482.482 0 00.482.482h9.64a.482.482 0 00.482-.482v-.964a.482.482 0 00-.48-.479zm0-9.64H5.3a.482.482 0 00-.482.482v.961a.482.482 0 00.482.482h9.64a.482.482 0 00.482-.482V.964a.482.482 0 00-.48-.482zm0 4.82H5.3a.482.482 0 00-.482.482v.964a.482.482 0 00.482.482h9.64a.482.482 0 00.482-.482v-.964a.482.482 0 00-.48-.482z"
        fill="#a5a4bf"
      />
    </svg>
  );
}
export function DollarIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15px"
      height="15px"
      viewBox="0 0 500 500"
    >
      <path d="M160 0c17.7 0 32 14.3 32 32V67.7c1.6 .2 3.1 .4 4.7 .7c.4 .1 .7 .1 1.1 .2l48 8.8c17.4 3.2 28.9 19.9 25.7 37.2s-19.9 28.9-37.2 25.7l-47.5-8.7c-31.3-4.6-58.9-1.5-78.3 6.2s-27.2 18.3-29 28.1c-2 10.7-.5 16.7 1.2 20.4c1.8 3.9 5.5 8.3 12.8 13.2c16.3 10.7 41.3 17.7 73.7 26.3l2.9 .8c28.6 7.6 63.6 16.8 89.6 33.8c14.2 9.3 27.6 21.9 35.9 39.5c8.5 17.9 10.3 37.9 6.4 59.2c-6.9 38-33.1 63.4-65.6 76.7c-13.7 5.6-28.6 9.2-44.4 11V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.1c-.4-.1-.9-.1-1.3-.2l-.2 0 0 0c-24.4-3.8-64.5-14.3-91.5-26.3c-16.1-7.2-23.4-26.1-16.2-42.2s26.1-23.4 42.2-16.2c20.9 9.3 55.3 18.5 75.2 21.6c31.9 4.7 58.2 2 76-5.3c16.9-6.9 24.6-16.9 26.8-28.9c1.9-10.6 .4-16.7-1.3-20.4c-1.9-4-5.6-8.4-13-13.3c-16.4-10.7-41.5-17.7-74-26.3l-2.8-.7 0 0C119.4 279.3 84.4 270 58.4 253c-14.2-9.3-27.5-22-35.8-39.6c-8.4-17.9-10.1-37.9-6.1-59.2C23.7 116 52.3 91.2 84.8 78.3c13.3-5.3 27.9-8.9 43.2-11V32c0-17.7 14.3-32 32-32z" />
    </svg>
  );
}
export function SearchIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 18.416 18.414" {...props}>
      <defs>
        <style>
          {
            ".prefix__cls-5{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"
          }
        </style>
      </defs>
      <g
        id="prefix__Icon_feather-search"
        data-name="Icon feather-search"
        transform="translate(-3.5 -3.5)"
      >
        <path
          id="prefix__Path_458"
          data-name="Path 458"
          className="prefix__cls-5"
          d="M18.5 11.5a7 7 0 11-7-7 7 7 0 017 7z"
        />
        <path
          id="prefix__Path_459"
          data-name="Path 459"
          className="prefix__cls-5"
          d="M29.325 29.325l-4.35-4.35"
          transform="translate(-8.824 -8.825)"
        />
      </g>
    </svg>
  );
}
export function SettingIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" {...props}>
      <path
        data-name="Path 108"
        d="M13.3 5.2l1.1-2.1L13 1.7l-2.1 1.1a3.582 3.582 0 00-1.1-.4L9 0H7l-.8 2.3a4.179 4.179 0 00-1 .4L3.1 1.6 1.6 3.1l1.1 2.1a4.179 4.179 0 00-.4 1L0 7v2l2.3.8c.1.4.3.7.4 1.1L1.6 13 3 14.4l2.1-1.1a3.582 3.582 0 001.1.4L7 16h2l.8-2.3c.4-.1.7-.3 1.1-.4l2.1 1.1 1.4-1.4-1.1-2.1a3.582 3.582 0 00.4-1.1L16 9V7l-2.3-.8a4.179 4.179 0 00-.4-1zM8 11a2.946 2.946 0 01-3-3 2.946 2.946 0 013-3 2.946 2.946 0 013 3 2.946 2.946 0 01-3 3z"
        fill="#a5a4bf"
      />
    </svg>
  );
}

export function SmallEditIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 13.174 11.708" {...props}>
      <path
        data-name="Icon awesome-edit"
        d="M9.208 1.901l2.063 2.063a.224.224 0 010 .316l-5 5-2.123.236a.445.445 0 01-.492-.492L3.9 6.893l5-5a.224.224 0 01.308.008zm3.705-.524L11.8.261a.9.9 0 00-1.263 0l-.81.81a.224.224 0 000 .316L11.79 3.45a.224.224 0 00.316 0l.81-.81a.9.9 0 000-1.263zm-4.13 6.539v2.328H1.464V2.925H6.72a.281.281 0 00.194-.08l.915-.915a.274.274 0 00-.194-.469H1.1A1.1 1.1 0 000 2.559v8.051a1.1 1.1 0 001.1 1.1h8.049a1.1 1.1 0 001.1-1.1V7.001a.275.275 0 00-.469-.194l-.915.915a.281.281 0 00-.082.194z"
        fill="#33c2df"
      />
    </svg>
  );
}
export function SortIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 5.747 7.996" {...props}>
      <path
        data-name="Icon awesome-sort"
        d="M.483 4.641h4.78a.483.483 0 01.341.823l-2.39 2.39a.48.48 0 01-.681 0L.142 5.464a.483.483 0 01.341-.823zm5.126-2.109L3.219.142a.48.48 0 00-.681 0L.142 2.532a.483.483 0 00.341.823h4.78a.483.483 0 00.346-.823z"
        fill="#fff"
      />
    </svg>
  );
}
export function TopArrowSubmenuIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 9.315 5.326" {...props}>
      <path
        data-name="Icon ionic-ios-arrow-down"
        d="M4.659 1.606l3.522 3.525a.663.663 0 00.94 0 .671.671 0 000-.943L5.13.194a.664.664 0 00-.918-.019L.193 4.185a.666.666 0 10.94.943z"
        fill="#FFFFFF"
      />
    </svg>
  );
}
export function UpIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 8 7" {...props}>
      <path
        data-name="Polygon 19"
        d="M4 0l4 7H0z"
        fill={props.type === "reverse" ? "#ff0505" : "#07ba00"}
      />
    </svg>
  );
}

export function LogoutIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20.283 16.704" {...props}>
      <g data-name="Group 3233" fill="#000">
        <path
          data-name="Icon open-account-login"
          d="M8.352 0v2.386h9.541v11.931H8.352V16.7h11.931V0z"
        />
        <path
          data-name="Icon open-account-login"
          d="M4.772 4.772v2.387h9.545v2.386H4.772v2.386L0 8.352z"
        />
      </g>
    </svg>
  );
}

export function GreenClockIconBank(props) {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m12 8v4l3 3m6-3c0 4.9706-4.0294 9-9 9-4.97056 0-9-4.0294-9-9 0-4.97056 4.02944-9 9-9 4.9706 0 9 4.02944 9 9z"
        stroke="#33c2df"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
    </svg>
  );
}

export function AmberClockIconBank(props) {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m12 8v4l3 3m6-3c0 4.9706-4.0294 9-9 9-4.97056 0-9-4.0294-9-9 0-4.97056 4.02944-9 9-9 4.9706 0 9 4.02944 9 9z"
        stroke="#FFC107"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
    </svg>
  );
}

export function RedClockIconBank(props) {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m12 8v4l3 3m6-3c0 4.9706-4.0294 9-9 9-4.97056 0-9-4.0294-9-9 0-4.97056 4.02944-9 9-9 4.9706 0 9 4.02944 9 9z"
        stroke="#F44336"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
    </svg>
  );
}

export function UpRedIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 8 7" {...props}>
      <path data-name="Polygon 19" d="M4 0l4 7H0z" fill="#ff0505" />
    </svg>
  );
}

export function DownGreenIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 8 7" {...props}>
      <path data-name="Polygon 21" d="M4 7L0 0h8z" fill="#07ba00" />
    </svg>
  );
}
export function IconCheck(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 11.84 8.829" {...props}>
      <path
        data-name="Icon awesome-check"
        d="M4.021 8.656L.173 4.808a.592.592 0 010-.837l.837-.837a.592.592 0 01.837 0L4.44 5.723 9.992.174a.592.592 0 01.837 0l.837.837a.592.592 0 010 .837L4.859 8.656a.592.592 0 01-.838 0z"
        fill="rgba(255,255,255,0.66)"
      />
    </svg>
  );
}
export function IconMoneySvgrepo(props) {
  return (
    <svg
      id="prefix__money-svgrepo-com"
      width="1em"
      height="1em"
      viewBox="0 0 49.338 49.337"
      {...props}
    >
      <defs>
        <style>{".prefix__cls-6{fill:#fff}"}</style>
      </defs>
      <g id="prefix__Group_3282" data-name="Group 3282">
        <g id="prefix__Group_3281" data-name="Group 3281">
          <path
            id="prefix__Path_3357"
            data-name="Path 3357"
            className="prefix__cls-6"
            d="M326.194 280.3a6.465 6.465 0 00-1.928 4.732v4.112a.822.822 0 001.645 0v-4.112a4.829 4.829 0 011.4-3.53l5.756-5.756a1.734 1.734 0 011.146-.532 1.393 1.393 0 011.08.432 1.415 1.415 0 01.433 1.08 1.734 1.734 0 01-.532 1.146l-4.111 4.112a.822.822 0 001.163 1.163l4.112-4.111a3.38 3.38 0 001.013-2.243 3.125 3.125 0 00-3.223-3.223 3.376 3.376 0 00-2.242 1.013z"
            transform="translate(-293.019 -247.202)"
          />
          <path
            id="prefix__Path_3358"
            data-name="Path 3358"
            className="prefix__cls-6"
            d="M9.045 180.737a.822.822 0 00.581-1.4L3 172.712a4.731 4.731 0 01-1.357-3.487V156.89a1.645 1.645 0 013.289 0v6.51a.822.822 0 001.645 0v-6.51a3.289 3.289 0 00-6.578 0v12.334a6.354 6.354 0 001.886 4.693l6.579 6.583a.82.82 0 00.581.237z"
            transform="translate(0 -6138.8)"
          />
          <path
            id="prefix__Path_3359"
            data-name="Path 3359"
            className="prefix__cls-6"
            d="M51.7 276.791a3.376 3.376 0 001.013 2.242l4.111 4.111a.822.822 0 001.163-1.163l-4.111-4.112a1.731 1.731 0 01-.532-1.145 1.415 1.415 0 01.433-1.08 1.4 1.4 0 011.08-.432 1.734 1.734 0 011.146.532l5.795 5.792a4.825 4.825 0 011.365 3.494v4.111a.822.822 0 101.645 0v-4.111a6.459 6.459 0 00-1.886-4.693l-5.756-5.756a3.376 3.376 0 00-2.242-1.013 3.125 3.125 0 00-3.223 3.223z"
            transform="translate(-46.713 -247.205)"
          />
          <path
            id="prefix__Path_3360"
            data-name="Path 3360"
            className="prefix__cls-6"
            d="M225.156 87.8a1.646 1.646 0 011.645 1.645.822.822 0 001.645 0 3.286 3.286 0 00-2.467-3.172v-.117a.822.822 0 10-1.645 0v.117a3.282 3.282 0 00.822 6.462 1.645 1.645 0 11-1.645 1.645.822.822 0 00-1.645 0 3.286 3.286 0 002.467 3.172v.117a.822.822 0 101.645 0v-.117a3.282 3.282 0 00-.822-6.462 1.645 1.645 0 010-3.289z"
            transform="translate(-200.487 -77.11)"
          />
          <path
            id="prefix__Path_3361"
            data-name="Path 3361"
            className="prefix__cls-6"
            d="M65.179 460.8H52.022a.822.822 0 00-.822.822v3.289a.822.822 0 101.645 0v-2.467h11.512v2.467a.822.822 0 101.645 0v-3.289a.822.822 0 00-.823-.822z"
            transform="translate(-46.266 -416.396)"
          />
          <path
            id="prefix__Path_3362"
            data-name="Path 3362"
            className="prefix__cls-6"
            d="M321.179 460.8h-13.157a.822.822 0 00-.822.822v3.289a.822.822 0 101.645 0v-2.467h11.512v2.467a.822.822 0 101.645 0v-3.289a.822.822 0 00-.823-.822z"
            transform="translate(-277.598 -416.396)"
          />
          <path
            id="prefix__Path_3363"
            data-name="Path 3363"
            className="prefix__cls-6"
            d="M148.045 34.133a11.512 11.512 0 1011.512 11.512 11.525 11.525 0 00-11.512-11.512zm0 21.38a9.867 9.867 0 119.868-9.868 9.878 9.878 0 01-9.868 9.868z"
            transform="translate(-123.376 -30.844)"
          />
          <path
            id="prefix__Path_3364"
            data-name="Path 3364"
            className="prefix__cls-6"
            d="M416.176 153.6a3.292 3.292 0 00-3.289 3.289v6.51a.822.822 0 101.645 0v-6.51a1.645 1.645 0 113.289 0v12.334a4.733 4.733 0 01-1.4 3.53l-6.578 6.578a.822.822 0 101.157 1.164l6.527-6.531a6.364 6.364 0 001.936-4.74v-12.335a3.293 3.293 0 00-3.287-3.289z"
            transform="translate(-370.128 -138.799)"
          />
          <path
            id="prefix__Path_3365"
            data-name="Path 3365"
            className="prefix__cls-6"
            d="M132 14.8a14.8 14.8 0 10-14.8 14.8A14.818 14.818 0 00132 14.8zm-14.8 13.158A13.157 13.157 0 11130.358 14.8 13.172 13.172 0 01117.2 27.958z"
            transform="translate(-92.533)"
          />
        </g>
      </g>
    </svg>
  );
}
export function IconDelete(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 10.547 13.56" {...props}>
      <path
        data-name="Icon material-delete"
        d="M.753 12.054A1.511 1.511 0 002.26 13.56h6.027a1.511 1.511 0 001.507-1.507v-9.04H.753zm9.794-11.3H7.91L7.157 0H3.39l-.753.753H0V2.26h10.547z"
        fill="#ff5353"
      />
    </svg>
  );
}
export function PlusIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20.044 20.044" {...props}>
      <path
        data-name="Icon material-add-box"
        d="M17.817 0H2.227A2.226 2.226 0 000 2.227v15.59a2.226 2.226 0 002.227 2.227h15.59a2.234 2.234 0 002.227-2.227V2.227A2.234 2.234 0 0017.817 0zM15.59 11.136h-4.454v4.454H8.908v-4.454H4.454V8.908h4.454V4.454h2.227v4.454h4.455z"
        fill="#33c2df"
      />
    </svg>
  );
}
export function IconCheckCircle(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 14.875 14.875" {...props}>
      <path
        data-name="Icon awesome-check-circle"
        d="M14.875 7.437A7.438 7.438 0 117.437 0a7.437 7.437 0 017.438 7.437zm-8.3 3.938l5.52-5.518a.48.48 0 000-.679l-.679-.679a.48.48 0 00-.679 0l-4.5 4.5-2.1-2.1a.48.48 0 00-.679 0l-.679.679a.48.48 0 000 .679l3.119 3.119a.48.48 0 00.679 0z"
        fill="#33c2df"
      />
    </svg>
  );
}
export function IconArrowDropdownCircle(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20.498 20.498" {...props}>
      <path
        data-name="Icon ionic-ios-arrow-dropdown-circle"
        d="M0 10.249A10.249 10.249 0 1010.249 0 10.247 10.247 0 000 10.249zm14.245-2.138a.955.955 0 011.345 0 .939.939 0 01.276.67.956.956 0 01-.281.675l-4.647 4.632a.95.95 0 01-1.313-.03l-4.716-4.7a.951.951 0 111.345-1.345l4 4.036z"
        fill="#ccc"
      />
    </svg>
  );
}
export function IconMail(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 22.287 15.43" {...props}>
      <defs>
        <style>{".prefix__cls-7{fill:#fff}"}</style>
      </defs>
      <g
        id="prefix__Icon_ionic-ios-mail"
        data-name="Icon ionic-ios-mail"
        transform="translate(-3.375 -7.875)"
      >
        <path
          id="prefix__Path_3587"
          data-name="Path 3587"
          className="prefix__cls-7"
          d="M25.48 10.347l-5.765 5.872a.1.1 0 000 .15l4.034 4.3a.7.7 0 010 .986.7.7 0 01-.986 0l-4.017-4.285a.11.11 0 00-.155 0l-.98 1a4.314 4.314 0 01-3.075 1.3 4.4 4.4 0 01-3.14-1.334l-.943-.959a.11.11 0 00-.155 0l-4.019 4.274a.7.7 0 01-.986 0 .7.7 0 010-.986l4.034-4.3a.114.114 0 000-.15l-5.77-5.872a.106.106 0 00-.182.075v11.753a1.719 1.719 0 001.714 1.714h18.859a1.719 1.719 0 001.714-1.714V10.422a.107.107 0 00-.182-.075z"
          transform="translate(0 -.581)"
        />
        <path
          id="prefix__Path_3588"
          data-name="Path 3588"
          className="prefix__cls-7"
          d="M14.721 17.685a2.913 2.913 0 002.095-.879l8.406-8.556a1.684 1.684 0 00-1.061-.375H5.287a1.673 1.673 0 00-1.061.375l8.406 8.556a2.913 2.913 0 002.089.879z"
          transform="translate(-.203)"
        />
      </g>
    </svg>
  );
}
export function IconRefresh(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 19.938 16.222" {...props}>
      <g
        data-name="Icon feather-refresh-cw"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path data-name="Path 3684" d="M19.232 1.374v5.052H14.18" />
        <path data-name="Path 3685" d="M.707 14.847V9.795h5.052" />
        <path
          data-name="Path 3686"
          d="M2.821 5.585a7.578 7.578 0 0112.5-2.829l3.911 3.675M.707 9.795l3.907 3.671a7.578 7.578 0 0012.5-2.829"
        />
      </g>
    </svg>
  );
}
function SaveSvg(props) {
  return (
    <svg width="1.4em" height="1.4em" viewBox="0 0 27.007 27.007" {...props}>
      <path
        data-name="Icon ionic-md-save"
        d="M21 0H3a3 3 0 00-3 3v21a3 3 0 003 3h21a3.01 3.01 0 003-3V6zm-7.5 24a4.5 4.5 0 114.5-4.5 4.5 4.5 0 01-4.5 4.5zM18 9H3V3h15z"
        fill="#fff"
      />
    </svg>
  );
}
const SaveIcon = React.memo(SaveSvg);

function ZoomInIconSVG(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 22.079 22.079" {...props}>
      <defs>
        <style>
          {
            ".prefix__cls-1{fill:none;stroke:#909090;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"
          }
        </style>
      </defs>
      <g
        id="prefix__Icon_feather-zoom-in"
        data-name="Icon feather-zoom-in"
        transform="translate(1 1)"
      >
        <path
          id="prefix__Path_3025"
          data-name="Path 3025"
          className="prefix__cls-1"
          d="M21.98 13.24a8.74 8.74 0 11-8.74-8.74 8.74 8.74 0 018.74 8.74z"
          transform="translate(-4.5 -4.5)"
        />
        <path
          id="prefix__Path_3026"
          data-name="Path 3026"
          className="prefix__cls-1"
          d="M29.727 29.727l-4.752-4.752"
          transform="translate(-10.063 -10.063)"
        />
        <path
          id="prefix__Path_3027"
          data-name="Path 3027"
          className="prefix__cls-1"
          d="M16.5 12v6.555"
          transform="translate(-7.76 -6.538)"
        />
        <path
          id="prefix__Path_3028"
          data-name="Path 3028"
          className="prefix__cls-1"
          d="M12 16.5h6.555"
          transform="translate(-6.538 -7.76)"
        />
      </g>
    </svg>
  );
}

const ZoomInIcon = React.memo(ZoomInIconSVG);

function ZoomOutIconSVG(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 22.079 22.079" {...props}>
      <defs>
        <style>
          {
            ".prefix__cls-1{fill:none;stroke:#909090;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"
          }
        </style>
      </defs>
      <g
        id="prefix__Icon_feather-zoom-out"
        data-name="Icon feather-zoom-out"
        transform="translate(1 1)"
      >
        <path
          id="prefix__Path_3029"
          data-name="Path 3029"
          className="prefix__cls-1"
          d="M21.98 13.24a8.74 8.74 0 11-8.74-8.74 8.74 8.74 0 018.74 8.74z"
          transform="translate(-4.5 -4.5)"
        />
        <path
          id="prefix__Path_3030"
          data-name="Path 3030"
          className="prefix__cls-1"
          d="M29.727 29.727l-4.752-4.752"
          transform="translate(-10.063 -10.063)"
        />
        <path
          id="prefix__Path_3031"
          data-name="Path 3031"
          className="prefix__cls-1"
          d="M12 16.5h6.555"
          transform="translate(-6.538 -7.76)"
        />
      </g>
    </svg>
  );
}

export function DeleteIcon(props) {
  return (
    <div {...props}>
      {" "}
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="delete">
        <path d="M24.2,12.193,23.8,24.3a3.988,3.988,0,0,1-4,3.857H12.2a3.988,3.988,0,0,1-4-3.853L7.8,12.193a1,1,0,0,1,2-.066l.4,12.11a2,2,0,0,0,2,1.923h7.6a2,2,0,0,0,2-1.927l.4-12.106a1,1,0,0,1,2,.066Zm1.323-4.029a1,1,0,0,1-1,1H7.478a1,1,0,0,1,0-2h3.1a1.276,1.276,0,0,0,1.273-1.148,2.991,2.991,0,0,1,2.984-2.694h2.33a2.991,2.991,0,0,1,2.984,2.694,1.276,1.276,0,0,0,1.273,1.148h3.1A1,1,0,0,1,25.522,8.164Zm-11.936-1h4.828a3.3,3.3,0,0,1-.255-.944,1,1,0,0,0-.994-.9h-2.33a1,1,0,0,0-.994.9A3.3,3.3,0,0,1,13.586,7.164Zm1.007,15.151V13.8a1,1,0,0,0-2,0v8.519a1,1,0,0,0,2,0Zm4.814,0V13.8a1,1,0,0,0-2,0v8.519a1,1,0,0,0,2,0Z"></path>
      </svg>
    </div>
  );
}

export function CommentIcon(props) {
  return (
    <svg
      {...props}
      className="noBarClick"
      style={{
        width: "20px",
        height: "20px",
        fill: "white",
        color: "white",
      }}
      enable-background="new 0 0 512 512"
      height="512px"
      id="Layer_1"
      version="1.1"
      viewBox="0 0 512 512"
      width="512px"
    >
      <path d="M170.476,166.19h155.097c4.285,0,7.76-3.469,7.76-7.754s-3.475-7.765-7.76-7.765H170.476c-4.285,0-7.754,3.48-7.754,7.765  S166.191,166.19,170.476,166.19z" />
      <path d="M348.088,203.362H202.74c-4.284,0-7.759,3.469-7.759,7.754s3.475,7.765,7.759,7.765h145.348c4.284,0,7.754-3.48,7.754-7.765  S352.372,203.362,348.088,203.362z" />
      <path d="M306.695,256.052H170.476c-4.285,0-7.754,3.469-7.754,7.754c0,4.284,3.469,7.754,7.754,7.754h136.219  c4.279,0,7.754-3.47,7.754-7.754C314.448,259.521,310.974,256.052,306.695,256.052z" />
      <path d="M396.776,86.288H115.225c-29.992,0-54.403,22.562-54.403,50.308v154.83c0,27.735,24.411,50.297,54.403,50.297h166.034  l119.812,83.989v-84.135c27.996-2.038,50.108-23.753,50.108-50.151v-154.83C451.179,108.85,426.768,86.288,396.776,86.288z   M427.906,291.426c0,14.902-13.972,27.025-31.131,27.025h-18.978v62.523l-89.193-62.523h-173.38  c-17.164,0-31.131-12.123-31.131-27.025v-154.83c0-14.913,13.967-27.035,31.131-27.035h281.551  c17.159,0,31.131,12.123,31.131,27.035V291.426z" />
    </svg>
  );
}

export function LoginIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      id="login"
      {...props}
    >
      <g data-name="Layer 2">
        <path
          d="M19 4h-2a1 1 0 0 0 0 2h1v12h-1a1 1 0 0 0 0 2h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm-7.2 3.4a1 1 0 0 0-1.6 1.2L12 11H4a1 1 0 0 0 0 2h8.09l-1.72 2.44a1 1 0 0 0 .24 1.4 1 1 0 0 0 .58.18 1 1 0 0 0 .81-.42l2.82-4a1 1 0 0 0 0-1.18z"
          data-name="log-in"
        ></path>
      </g>
    </svg>
  );
}

export function SyncIcon(props) {
  return (
    <svg viewBox="0 0 24 24" {...props} fill="none">
      <g clip-path="url(#clip0_429_11068)">
        <path
          d="M3 11.9998C3 7.02925 7.02944 2.99982 12 2.99982C14.8273 2.99982 17.35 4.30348 19 6.34248"
          stroke="#fff"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.5 2.99982L19.5 6.99982L15.5 6.99982"
          stroke="#fff"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21 11.9998C21 16.9704 16.9706 20.9998 12 20.9998C9.17273 20.9998 6.64996 19.6962 5 17.6572"
          stroke="#fff"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.5 20.9998L4.5 16.9998L8.5 16.9998"
          stroke="#fff"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  );
}

export function Tenants(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 62 62"
      id="users"
      {...props}
    >
      <g fill="none" fill-rule="evenodd">
        <g fill="#000" transform="translate(-609 -140)">
          <g transform="translate(608 139)">
            <path d="M51.81 35.962h-6.4c-.915 0-1.524-.61-1.524-1.524s.61-1.524 1.524-1.524h6.4c1.523 0 3.047-.304 4.571-.61.914-.304 1.524-.609 2.133-.914.61-.304.915-1.219.915-1.828 0-.61-.305-1.22-.61-1.829-1.524-1.828-4.267-3.047-7.924-4.266-.305 0-.305-.305-.61-.305-.914-.61-1.523-1.524-1.828-2.438 0-1.22.61-2.134 1.524-2.743 2.133-3.048 3.352-5.79 3.048-8.229-.305-1.523-.915-2.742-2.134-3.657-2.133-1.524-5.18-1.524-7.01 0-1.218.915-1.828 2.134-2.133 3.657-.304 2.438.915 5.181 3.048 8.229.61.61.305 1.524-.305 2.133-.61.61-1.524.305-2.133-.304-3.048-3.658-4.267-7.315-3.657-10.667.305-2.133 1.524-4.267 3.352-5.486 3.048-2.438 7.62-2.438 10.667 0 1.828 1.524 3.047 3.353 3.352 5.486.305 3.352-.914 7.01-3.657 10.667-.305.304-.305.609-.61.609 0 0 .305 0 .305.305 3.962 1.219 7.01 3.047 8.838 5.18.915.915 1.524 2.439 1.524 3.963a5.332 5.332 0 01-2.133 4.266c-.914.61-1.829 1.22-3.048 1.524-1.828 0-3.657.305-5.485.305zM18.59 35.962h-6.4c-2.133 0-3.961-.305-5.485-.914-1.22-.305-2.134-.915-3.048-1.524-1.219-.914-2.133-2.743-2.133-4.267 0-1.524.61-2.743 1.524-3.962 2.133-2.133 5.18-3.657 9.142-4.876 0 0 .305 0 .305-.305 0 0-.305-.304-.305-.61C9.143 15.849 7.62 11.887 8.23 8.839c.304-2.133 1.523-4.267 3.352-5.486 3.048-2.438 7.619-2.438 10.667 0 1.828 1.524 3.047 3.353 3.352 5.486.305 3.352-.914 7.01-3.657 10.667-.61.61-1.524.61-2.133.305-.61-.61-.915-1.524-.305-2.134 2.438-3.047 3.352-6.095 3.047-8.228 0-1.524-.914-2.743-2.133-3.658-2.133-1.523-4.876-1.523-7.01 0-1.219.915-2.133 2.134-2.133 3.353-.305 2.438.914 5.18 3.048 8.228.61.915 1.524 1.829 1.219 2.743 0 1.22-.914 1.829-1.829 2.438 0 0-.304.305-.61.305-3.352 1.524-5.79 2.743-7.618 4.572-.305.61-.61 1.219-.61 1.828 0 .914.305 1.524.914 1.829.61.304 1.22.61 2.134.914 1.219.61 2.743.914 4.266.914h6.4c.915 0 1.524.61 1.524 1.524s-.61 1.524-1.524 1.524z"></path>
            <path d="M38.4 62.476H25.905c-2.743 0-5.181-.305-7.315-1.219-1.523-.61-2.742-1.219-3.657-2.133-1.828-.914-2.743-3.048-2.743-5.181 0-1.829.61-3.353 1.829-4.876 2.438-2.743 6.4-4.877 11.886-6.705l.914-.914-.914-.915c-3.962-5.18-5.79-9.752-5.181-14.019.61-2.743 1.828-5.18 4.266-7.01 3.962-2.742 10.058-2.742 13.715 0 2.438 1.83 3.962 4.267 4.266 7.01.61 4.267-1.219 9.143-4.876 14.02-.914.914-.914 1.218-.914 1.218s.61.305.914.61c5.486 1.828 9.448 3.962 11.886 6.705 1.219 1.219 1.829 3.047 1.829 4.876 0 2.133-.915 4.267-2.439 5.486-.914.914-2.133 1.523-3.657 2.133-2.438.61-4.876.914-7.314.914zM32 20.114c-1.829 0-3.657.61-5.181 1.524-1.829 1.22-2.743 3.048-3.048 5.181-.304 3.352 1.22 7.314 4.267 11.581.914.914 1.829 1.829 1.524 3.352 0 1.22-1.22 2.134-2.133 3.048 0 0-.305.305-.61.305-5.18 1.524-8.533 3.657-10.971 6.095-.305.61-.61 1.829-.61 2.743 0 1.219.61 2.438 1.524 3.047.61.61 1.828 1.22 3.048 1.524 1.828.61 3.961.915 6.095.915H38.4c2.133 0 4.267-.305 6.095-.915 1.22-.304 2.134-.914 3.048-1.524.914-.609 1.524-1.828 1.524-3.047 0-.914-.305-2.133-1.22-2.743-2.133-2.438-5.79-4.267-10.97-6.095-.306 0-.306-.305-.61-.305-.915-.914-2.134-1.829-2.134-3.048s.915-2.438 1.829-3.352c3.048-3.962 4.571-8.229 4.267-11.581-.305-2.133-1.22-3.657-3.048-5.18-1.524-.915-3.352-1.525-5.181-1.525z"></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export function User(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1024 1024"
      id="user"
      {...props}
    >
      <path d="M670.1 278.4c0 8.8-.6 17.6-1.7 26.3.5-3.5 1-7.1 1.4-10.6-2.4 17.4-7 34.3-13.7 50.5 1.3-3.2 2.7-6.4 4-9.6-6.7 15.8-15.3 30.6-25.8 44.2l6.3-8.1c-10.4 13.4-22.5 25.5-35.9 35.9l8.1-6.3c-13.6 10.4-28.4 19.1-44.2 25.8 3.2-1.3 6.4-2.7 9.6-4-16.2 6.7-33.1 11.3-50.5 13.7 3.5-.5 7.1-1 10.6-1.4-17.5 2.3-35.1 2.3-52.6 0 3.5.5 7.1 1 10.6 1.4-17.4-2.4-34.3-7-50.5-13.7 3.2 1.3 6.4 2.7 9.6 4-15.8-6.7-30.6-15.3-44.2-25.8l8.1 6.3c-13.4-10.4-25.5-22.5-35.9-35.9l6.3 8.1c-10.4-13.6-19.1-28.4-25.8-44.2 1.3 3.2 2.7 6.4 4 9.6-6.7-16.2-11.3-33.1-13.7-50.5.5 3.5 1 7.1 1.4 10.6-2.3-17.5-2.3-35.1 0-52.6-.5 3.5-1 7.1-1.4 10.6 2.4-17.4 7-34.3 13.7-50.5-1.3 3.2-2.7 6.4-4 9.6 6.7-15.8 15.3-30.6 25.8-44.2l-6.3 8.1c10.4-13.4 22.5-25.5 35.9-35.9l-8.1 6.3c13.6-10.4 28.4-19.1 44.2-25.8-3.2 1.3-6.4 2.7-9.6 4 16.2-6.7 33.1-11.3 50.5-13.7-3.5.5-7.1 1-10.6 1.4 17.5-2.3 35.1-2.3 52.6 0-3.5-.5-7.1-1-10.6-1.4 17.4 2.4 34.3 7 50.5 13.7-3.2-1.3-6.4-2.7-9.6-4 15.8 6.7 30.6 15.3 44.2 25.8l-8.1-6.3c13.4 10.4 25.5 22.5 35.9 35.9l-6.3-8.1c10.4 13.6 19.1 28.4 25.8 44.2-1.3-3.2-2.7-6.4-4-9.6 6.7 16.2 11.3 33.1 13.7 50.5-.5-3.5-1-7.1-1.4-10.6 1.1 8.7 1.6 17.5 1.7 26.3.1 20.9 18.3 41 40 40 21.6-1 40.1-17.6 40-40-.2-47.9-14.6-96.9-42.8-135.9-7.6-10.5-15.7-20.8-24.7-30.1-9.1-9.4-19.1-17.5-29.5-25.4-18.9-14.4-40-25-62.4-33.2-90.3-33.1-199.2-3.6-260.3 70.8-8.4 10.2-16.4 20.8-23.2 32.2-6.8 11.3-12.1 23.3-17 35.5-9.2 22.6-13.9 46.6-15.8 70.9-3.7 47.6 8.7 97.3 33.5 138.1 23.9 39.4 60 73.2 102.2 92.3 12.4 5.6 25.1 10.8 38.3 14.5 13.1 3.6 26.4 5.6 39.9 7.2 24.6 2.9 49.7.9 74-4 92.3-18.8 169.6-98.3 183.9-191.6 2.1-13.6 3.7-27.2 3.7-41 .1-20.9-18.5-41-40-40-21.6.7-39.8 17.3-39.8 39.7zm132.7 625.3H289.7c-22.7 0-45.4.2-68.1 0-2.5 0-5-.2-7.4-.5 3.5.5 7.1 1 10.6 1.4-4-.6-7.8-1.7-11.5-3.2 3.2 1.3 6.4 2.7 9.6 4-4-1.7-7.7-3.9-11.2-6.6l8.1 6.3c-3-2.5-5.8-5.2-8.2-8.2l6.3 8.1c-2.7-3.5-4.8-7.2-6.6-11.2 1.3 3.2 2.7 6.4 4 9.6-1.5-3.7-2.5-7.6-3.2-11.5.5 3.5 1 7.1 1.4 10.6-1.6-12.1-.5-24.9-.5-37.1v-42.8c0-10.7.6-21.3 2-31.9-.5 3.5-1 7.1-1.4 10.6 2.8-20.5 8.2-40.6 16.3-59.7-1.3 3.2-2.7 6.4-4 9.6 7.8-18.2 17.8-35.3 29.9-51l-6.3 8.1c12.1-15.5 26-29.5 41.6-41.6L283 673c15.7-12.1 32.8-22.1 51-29.9-3.2 1.3-6.4 2.7-9.6 4 19.1-8 39.1-13.5 59.7-16.3-3.5.5-7.1 1-10.6 1.4 14.8-1.9 29.5-2 44.4-2h183c16.5 0 32.9-.1 49.4 2-3.5-.5-7.1-1-10.6-1.4 20.5 2.8 40.6 8.2 59.7 16.3-3.2-1.3-6.4-2.7-9.6-4 18.2 7.8 35.3 17.8 51 29.9l-8.1-6.3c15.5 12.1 29.5 26 41.6 41.6l-6.3-8.1c12.1 15.7 22.1 32.8 29.9 51-1.3-3.2-2.7-6.4-4-9.6 8 19.1 13.5 39.1 16.3 59.7-.5-3.5-1-7.1-1.4-10.6 1.9 15.1 2 30.1 2 45.3v49.5c0 5.7.2 11.4-.5 17 .5-3.5 1-7.1 1.4-10.6-.6 4-1.7 7.8-3.2 11.5 1.3-3.2 2.7-6.4 4-9.6-1.7 4-3.9 7.7-6.6 11.2l6.3-8.1c-2.5 3-5.2 5.8-8.2 8.2l8.1-6.3c-3.5 2.7-7.2 4.8-11.2 6.6 3.2-1.3 6.4-2.7 9.6-4-3.7 1.5-7.6 2.5-11.5 3.2 3.5-.5 7.1-1 10.6-1.4-2.2.3-4.5.4-6.8.5-10.3.1-20.9 4.4-28.3 11.7-6.9 6.9-12.2 18.3-11.7 28.3 1 21.4 17.6 40.3 40 40 38.9-.6 73.1-26 84.5-63.3 4.5-14.8 3.5-30.7 3.5-45.9 0-34.8 1.1-69.3-4.9-103.8-8.8-50.5-34.2-98-69-135.3-34.8-37.3-81.6-64.7-131.1-76.9-28.4-7-57-8.1-86-8.1H422.4c-29.7 0-59.2 1.4-88.1 9.1-49.1 13-95.3 40.7-129.4 78.3-34.4 37.9-59.3 85.5-67.4 136.3-5.4 34.1-4.3 68.3-4.3 102.7 0 15.8-.9 32.3 4.8 47.4 7.4 19.4 19.2 34.7 36.5 46.2 13.5 8.9 30.6 13.2 46.6 13.4 7.8.1 15.6 0 23.4 0h558.4c20.9 0 41-18.4 40-40-1-21.8-17.6-40.1-40.1-40.1z"></path>
    </svg>
  );
}

export function Session(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M16 14L12 12V7M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" />
    </svg>
  );
}

export function Analytics(props) {
  return (
    <svg
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.5 19C16.366 19 19.5 15.866 19.5 12H12.5V5C8.63401 5 5.5 8.13401 5.5 12C5.5 15.866 8.63401 19 12.5 19Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.833 9.66702V5.40002C16.8253 6.10729 18.3927 7.67474 19.1 9.66702H14.833Z"
      />
    </svg>
  );
}

export function DataLoads(props) {
  return (
    <svg
      viewBox="0 0 1024 1024"
      class="icon"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M702.537143 218.477714c31.085714-10.825143 55.003429-23.113143 69.924571-35.328 10.24-8.338286 13.458286-13.824 13.458286-16.018285s-3.218286-7.68-13.458286-16.091429c-14.921143-12.141714-38.765714-24.429714-69.924571-35.254857C634.368 92.16 540.013714 78.336 438.857143 78.336s-195.510857 13.897143-263.68 37.449143c-31.085714 10.825143-55.003429 23.113143-69.924572 35.328-10.24 8.338286-13.458286 13.750857-13.458285 16.018286 0 2.194286 3.218286 7.68 13.458285 16.091428 14.921143 12.141714 38.765714 24.429714 69.924572 35.254857 68.169143 23.625143 162.523429 37.449143 263.68 37.449143s195.510857-13.897143 263.68-37.449143zM69.485714 464.749714v128.804572c37.961143 40.009143 140.068571 88.722286 264.777143 103.277714 182.857143 21.284571 355.986286-18.651429 473.526857-98.304l0.438857-131.657143C683.008 540.525714 506.733714 571.465143 328.484571 550.619429c-110.372571-12.8-204.361143-46.08-259.072-85.869715z m0-80.457143c38.034286 39.936 140.068571 88.649143 264.777143 103.131429 183.222857 21.357714 356.717714-18.724571 474.258286-98.742857l0.512-145.993143C734.208 286.573714 596.48 315.977143 438.857143 315.977143c-156.964571 0-294.253714-29.257143-369.152-72.777143A132116.333714 132116.333714 0 0 0 69.485714 384.219429z m0.146286 289.865143l0.292571 108.105143-1.097142-7.460571c22.381714 74.020571 165.302857 133.485714 378.148571 133.485714 115.931429 0 206.774857-17.554286 276.626286-52.077714 19.602286-9.728 34.523429-17.92 49.152-28.598857 9.728-7.094857 16.091429-11.410286 26.550857-20.626286 10.825143-9.581714 27.501714-7.241143 37.156571 3.657143 9.581714 10.752 10.825143 28.306286 0 37.961143-11.702857 10.24-17.188571 14.848-28.598857 23.186285-17.042286 12.434286-36.425143 25.380571-58.806857 36.498286-77.092571 38.107429-155.648 60.854857-302.08 60.854857-243.931429 0-405.211429-77.165714-436.077714-179.2l-1.097143-3.657143v-3.803428L9.362286 628.077714a116682.532571 116682.532571 0 0 1 0.365714-455.68 52.662857 52.662857 0 0 1-0.292571-5.266285C9.508571 84.918857 201.728 18.285714 438.857143 18.285714c237.129143 0 429.348571 66.633143 429.348571 148.845715a53.028571 53.028571 0 0 1-0.804571 9.581714 23.405714 23.405714 0 0 1 1.024 7.094857l-1.682286 520.411429c-0.073143 14.482286-13.385143 26.185143-29.769143 26.112-16.384 0-29.622857-11.776-29.549714-26.331429v-27.355429c-125.074286 73.216-301.056 104.082286-478.939429 83.382858-110.226286-12.873143-204.214857-46.08-258.925714-85.869715z m668.525714-290.962285a25.746286 25.746286 0 0 1-25.965714-25.453715c0-14.043429 11.702857-25.380571 26.038857-25.380571 14.336 0 26.038857 11.337143 26.038857 25.380571 0 14.116571-11.702857 25.453714-26.038857 25.453715z m0 209.408a25.746286 25.746286 0 0 1-25.965714-25.453715c0-14.043429 11.702857-25.453714 26.038857-25.453714 14.336 0 26.038857 11.410286 26.038857 25.453714 0 14.043429-11.702857 25.453714-26.038857 25.453715z m0 212.114285a25.746286 25.746286 0 0 1-25.965714-25.526857c0-14.043429 11.702857-25.453714 26.038857-25.453714 14.336 0 26.038857 11.410286 26.038857 25.453714 0 14.043429-11.702857 25.453714-26.038857 25.453714z"
        fill="#000000"
      />
    </svg>
  );
}

export function Subscriptions(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="cardsIconTitle"
      stroke="#a5a4bf"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
      color="white"
      {...props}
    >
      {" "}
      <title id="cardsIconTitle">Cards</title>{" "}
      <rect width="13" height="13" x="3" y="3" />{" "}
      <polyline points="16 8 21 8 21 21 8 21 8 16" />{" "}
    </svg>
  );
}

export function Switch(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.7153 1.71609C18.3241 1.32351 18.3241 0.687013 18.7153 0.294434C19.1066 -0.0981448 19.7409 -0.0981448 20.1321 0.294434L22.4038 2.57397L22.417 2.58733C23.1935 3.37241 23.1917 4.64056 22.4116 5.42342L20.1371 7.70575C19.7461 8.09808 19.1122 8.09808 18.7213 7.70575C18.3303 7.31342 18.3303 6.67733 18.7213 6.285L20.0018 5L4.99998 5C4.4477 5 3.99998 5.44772 3.99998 6V13C3.99998 13.5523 3.55227 14 2.99998 14C2.4477 14 1.99998 13.5523 1.99998 13V6C1.99998 4.34315 3.34313 3 4.99998 3H19.9948L18.7153 1.71609Z"
        fill="#0F0F0F"
      />
      <path
        d="M22 11C22 10.4477 21.5523 10 21 10C20.4477 10 20 10.4477 20 11V18C20 18.5523 19.5523 19 19 19L4.00264 19L5.28213 17.7161C5.67335 17.3235 5.67335 16.687 5.28212 16.2944C4.8909 15.9019 4.2566 15.9019 3.86537 16.2944L1.59369 18.574L1.58051 18.5873C0.803938 19.3724 0.805727 20.6406 1.58588 21.4234L3.86035 23.7058C4.25133 24.0981 4.88523 24.0981 5.2762 23.7058C5.66718 23.3134 5.66718 22.6773 5.2762 22.285L3.99563 21L19 21C20.6568 21 22 19.6569 22 18L22 11Z"
        fill="#0F0F0F"
      />
    </svg>
  );
}

export function DeActivateIcon(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="12" cy="12" r="9" stroke="#ffffff" stroke-width="2" />
      <path d="M18 18L6 6" stroke="#ffffff" stroke-width="2" />
    </svg>
  );
}

export function ActivateIcon(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.29417 12.9577L10.5048 16.1681L17.6729 9"
        stroke="#ffffff"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle cx="12" cy="12" r="10" stroke="#ffffff" stroke-width="2" />
    </svg>
  );
}

export function CronClock(props) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
    >
      <g>
        <path
          stroke="#ffffff"
          d="M118.77,0c32.8,0,62.49,13.29,83.98,34.79c21.49,21.49,34.79,51.19,34.79,83.98s-13.29,62.49-34.79,83.98 c-21.49,21.49-51.19,34.79-83.98,34.79c-32.8,0-62.49-13.29-83.98-34.79C13.29,181.26,0,151.56,0,118.77s13.29-62.49,34.79-83.98 C56.28,13.29,85.97,0,118.77,0L118.77,0z M109.06,60.2c0-3.59,2.91-6.5,6.5-6.5s6.5,2.91,6.5,6.5v60l45.14,26.76 c3.08,1.82,4.11,5.8,2.29,8.89c-1.82,3.08-5.8,4.11-8.89,2.29l-47.99-28.45c-2.11-1.08-3.55-3.27-3.55-5.79V60.2L109.06,60.2z M193.56,43.98C174.42,24.84,147.98,13,118.77,13c-29.21,0-55.65,11.84-74.79,30.98C24.84,63.12,13,89.56,13,118.77 c0,29.21,11.84,55.65,30.98,74.79c19.14,19.14,45.58,30.98,74.79,30.98c29.21,0,55.65-11.84,74.79-30.98 c19.14-19.14,30.98-45.58,30.98-74.79C224.54,89.56,212.7,63.12,193.56,43.98L193.56,43.98z"
        />
      </g>
    </svg>
  );
}


export function IconContractArrow(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 3.355 5.747" {...props}>
      <path
        data-name="Icon awesome-sort"
        d="M.823 5.609l2.39-2.39a.48.48 0 000-.681L.823.142A.483.483 0 000 .483v4.78a.483.483 0 00.823.346z"
        fill="#fff"
        transform="rotate(90 1.6775 2.8735)"
      />
    </svg>
  );
}

export function ExportIconWhite(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 31 21.7" {...props}>
      <path
        data-name="Icon awesome-cloud-download-alt"
        d="M26.04 9.426A4.656 4.656 0 0021.7 3.1a4.626 4.626 0 00-2.582.785A7.751 7.751 0 004.65 7.75c0 .131 0 .262.01.392A6.977 6.977 0 006.975 21.7H24.8a6.2 6.2 0 001.24-12.274zm-6.437 4.3L14.5 18.828a.778.778 0 01-1.095 0L8.3 13.722a.775.775 0 01.547-1.322h3.168V6.975a.777.777 0 01.775-.775h2.325a.777.777 0 01.775.775V12.4h3.168a.775.775 0 01.547 1.322z"
        fill="#fff"
      />
    </svg>
  );
}

export function TransactionIcon(props) {
  return (
    // <svg width="1em" height="1em" viewBox="0 0 15.424 12.532" {...props}>
    // <img src={transactionIcon} alt="transactionIcon" style={{ height: "12px", width: "20px" }} />

    // </svg>
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="#a5a4bf" class="bi bi-arrow-left-right" viewBox="0 0 16 16">
      <path d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5m14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5" />
    </svg>

  );
}
const ZoomOutIcon = React.memo(ZoomOutIconSVG);
export { SaveIcon, ZoomInIcon, ZoomOutIcon };
export function HamburgerIcon(props) {
  return (
    <svg
      width="1.5em"
      height="1.5em"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <path d="M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z" />
    </svg>
  );
}

export function CommentIcone(props) {
  return (<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="1rem" viewBox="0 0 30 30" {...props}>
    <path fill="#33c2df" d="M 15 3 C 7.82 3 2 7.925 2 14 C 2 17.368 3.7933281 20.378484 6.6113281 22.396484 C 6.6832805 23.932468 6.4452784 26.053382 4.3261719 27.03125 A 0.5 0.5 0 0 0 4.3222656 27.033203 A 0.5 0.5 0 0 0 4 27.5 A 0.5 0.5 0 0 0 4.5 28 C 4.5119372 28 4.5232366 27.998109 4.5351562 27.998047 A 0.5 0.5 0 0 0 4.5429688 27.998047 C 6.9769949 27.982445 9.0432734 26.667034 10.46875 25.277344 C 10.92075 24.836344 11.550875 24.619328 12.171875 24.736328 C 13.081875 24.909328 14.028 25 15 25 C 22.18 25 28 20.075 28 14 C 28 7.925 22.18 3 15 3 z"></path>
  </svg>)
}